<template>
  <div>
    <div v-if="isLoading">
      <Skeleton
        class="order-cards__skeleton"
        width="100%"
        style="margintop: 0"
        height="110px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="100%"
        style="margintop: 15px"
        height="141px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="240px"
        style="margintop: 15px"
        height="20px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="100%"
        style="margintop: 3px"
        height="40px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="220px"
        style="margintop: 15px"
        height="20px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="100%"
        style="margintop: 3px"
        height="40px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="160px"
        style="margintop: 15px"
        height="20px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="100%"
        style="margintop: 3px"
        height="40px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="240px"
        style="margintop: 15px"
        height="20px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="175px"
        style="margintop: 5px"
        height="43px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="110px"
        style="margintop: 25px"
        height="40px"
      />
      <Skeleton
        class="order-cards__skeleton"
        width="100%"
        style="margintop: 10px"
        height="15px"
      />
    </div>

    <div v-else>
      <Toast class="toast-msg" position="bottom-right" />
      <div class="existingrefund-header">
        <div>
          <div class="refund-states__refund-item__number">
            <img
              :src="require(`../assets/images/support-ticket.svg`)"
              alt=""
              class="refund-states__refund-item__icon"
              title="Номер заявки"
            />
            <p>{{ this.offer.offer.Id }}</p>
          </div>
          <div class="refund-states__refund-item__date">
            <img
              :src="require(`../assets/images/calendar.svg`)"
              alt=""
              class="refund-states__refund-item__icon"
            />
            <p>{{ getCreatedDate(this.offer.offer.DateCreate) }}</p>
          </div>
          <div v-if="this.offer.offer.TotalRefund != 0 || this.offer.offer.StateId == 30" class="refund-states__refund-item__date">
            <img
              :src="require(`../assets/images/return.svg`)"
              alt=""
              class="refund-states__refund-item__icon"
            />
            <p>{{ "К возврату: " +  this.offer.offer.TotalRefund + " руб."}}</p>
          </div>
          <div
            v-if="
              this.offer.offer.StateId == 10 || this.offer.offer.StateId == 20
            "
            class="refund-states__refund-item__status"
          >
            <div class="refund-states__refund-item__status-icon">
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <ellipse cx="4" cy="3.5" rx="4" ry="3.5" fill="#F37E21" />
              </svg>
            </div>
            <p>{{ getOfferStatus(this.offer.offer.StateId) }}</p>
          </div>
          <div
            v-else-if="this.offer.offer.StateId == 30"
            class="refund-states__refund-item__status"
          >
            <div class="refund-states__refund-item__status-icon">
              <svg
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <ellipse cx="4" cy="3.5" rx="4" ry="3.5" fill="#6BC242" />
              </svg>
            </div>
            <p>{{ getOfferStatus(this.offer.offer.StateId) }}</p>
          </div>
        </div>
      </div>
      <div
        v-for="(customer, index) in this.offer.customers"
        :key="index"
        :offer="this.offer"
        class="refund-main__segments"
      >
        <div class="refund-main__segment-card">
          <div>
            <div class="refund-main__segment-card__passenger">
              <div class="refund-main__segment-card__passenger-name">
                <img
                  :src="require(`../assets/images/person.svg`)"
                  alt=""
                  class="refund-main__segment-card__passenger-name__icon"
                />
                <p class="refund-main__segment-card__passenger-name__text">
                  {{ nameCaseChanger(customer.LastName) }}
                </p>
              </div>
              <div class="refund-main__segment-card__passenger-ticket">
                <img
                  :src="require(`../assets/images/boarding-pass.svg`)"
                  alt=""
                  class="refund-main__segment-card__passenger-ticket__icon"
                />
                <p class="refund-main__segment-card__passenger-ticket__text">
                  {{ customer.TicketNumber }}
                </p>
              </div>
            </div>
            <div
              v-for="info in customer.segments"
              :key="info.SegNumber"
              class="refund-main__segment-card__segment"
            >
              <Accordion>
                <AccordionTab>
                  <template
                    #header
                    class="refund-main__segment-card__accordion-header"
                  >
                    <span>{{
                      "Рейс " +
                      info.CarrCode.replace(/ /g, "") +
                      "-" +
                      info.FlNumber.replace(/ /g, "")
                    }}</span>
                    <input
                      type="checkbox"
                      checked
                      disabled
                      name=""
                      id=""
                      class="refund-main__segment-card__accordion-header__check"
                    />
                  </template>
                  <div class="refund-main__segment-card__segment-date">
                    <p class="refund-main__segment-card__segment-date__header">
                      Дата перелёта
                    </p>
                    <p class="refund-main__segment-card__segment-date__text">
                      {{ getDate(info.DptDt) + ", " + getWeekDay(info.DptDt) }}
                    </p>
                  </div>
                  <div class="refund-main__segment-card__segment-airline">
                    <p
                      class="refund-main__segment-card__segment-airline__header"
                    >
                      Номер рейса
                    </p>
                    <div
                      class="
                        refund-main__segment-card__segment-airline__wrapper
                      "
                    >
                      <img
                        class="refund-main__segment-card__segment-airline__icon"
                        :src="`https://www.biletdv.ru/Content/images/companies/${info.CarrCode.replace(
                          / /g,
                          ''
                        )}.svg`"
                        alt="company logo"
                      />
                      <p
                        class="refund-main__segment-card__segment-airline__text"
                      >
                        {{
                          info.CarrCode.replace(/ /g, "") +
                          "-" +
                          info.FlNumber.replace(/ /g, "")
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="refund-main__segment-card__segment-route">
                    <p class="refund-main__segment-card__segment-route__header">
                      Маршрут
                    </p>
                    <div
                      class="refund-main__segment-card__segment-route__wrapper"
                    >
                      <p class="refund-main__segment-card__segment-route__text">
                        {{ info.DAport }}
                      </p>
                      <div
                        class="refund-main__segment-card__segment-route__icon"
                      >
                        <svg
                          width="15"
                          height="11"
                          viewBox="0 0 15 11"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.535 4.73432L9.8475 1.63988C9.27 1.25901 8.38031 1.29201 7.86094 1.71688C7.34156 2.13969 7.38844 2.79213 7.96594 3.173L9.92813 4.46894H1.40625C0.629063 4.46894 0 4.93025 0 5.50019C0 6.07013 0.629063 6.53144 1.40625 6.53144H9.93L7.965 7.82738C7.3875 8.20894 7.34062 8.86069 7.86 9.2835C8.13844 9.50969 8.52188 9.62519 8.90625 9.62519C9.24188 9.62519 9.57844 9.53788 9.84656 9.3605L14.5341 6.26744C14.8303 6.07219 15 5.79307 15 5.50088C15 5.20869 14.8303 4.92957 14.535 4.73432Z"
                            fill="black"
                          />
                        </svg>
                      </div>
                      <p class="refund-main__segment-card__segment-route__text">
                        {{ info.AAport }}
                      </p>
                    </div>
                  </div>
                  <div class="refund-main__segment-card__segment-state">
                    <p class="refund-main__segment-card__segment-state__header">
                      Статус возврата
                    </p>
                    <p class="refund-main__segment-card__segment-state__text">
                      {{ info.IsReturned ? "Место на рейсе сдано" : "Место на рейсе не сдано" }}
                    </p>
                  </div>
                </AccordionTab>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
      <p class="refund-main__mail">Адрес электронной почты (E-mail)</p>
      <InputText type="text" v-model="this.offer.offer.Email" disabled />
      <p class="refund-main__phone">Контактный номер телефона</p>
      <InputText type="text" v-model="this.offer.offer.PhoneNumber" disabled />
      <p class="refund-main__reason">Причина возврата:</p>
      <Dropdown
        class="refund-main__reason-dropdown"
        v-model="selectedReason"
        :options="reasons"
        optionLabel="name"
        placeholder="Выберите причину"
        disabled
      />
      <div
        v-if="this.selectedReason.name == 'Не предоставили место на рейсе'"
        class="refund-main__reason-description__item"
      >
        <p class="refund-main__reason-description__item-text">
          Несостоявшаяся отправка пассажира из-за невозможности предоставить ему
          место на рейс и дату, указанные в билете.
        </p>
      </div>
      <div
        v-else-if="this.selectedReason.name == 'Задержали при досмотре'"
        class="refund-main__reason-description__item"
      >
        <p class="refund-main__reason-description__item-text">
          Несостоявшаяся перевозка пассажира на воздушном судне, вызванная
          задержкой пассажира в аэропорту из-за продолжительности проведения его
          досмотра, если при досмотре багажа или личном досмотре пассажира не
          было обнаружено запрещенных к перевозке веществ и предметов.
        </p>
      </div>
      <div
        v-else-if="this.selectedReason.name == 'Нарушена стыковка'"
        class="refund-main__reason-description__item"
      >
        <p class="refund-main__reason-description__item-text">
          Необеспечение перевозчиком стыковки рейсов в случае выполнения единой
          перевозки.
        </p>
      </div>
      <div
        v-else-if="
          this.selectedReason.name == 'Болезнь пассажира или члена его семьи'
        "
        class="refund-main__reason-description__item"
      >
        <p class="refund-main__reason-description__item-text">
          Болезнь пассажира или члена его семьи либо близкого родственника,
          совместно следующего с ним на воздушном судне, является основанием для
          вынужденного отказа пассажира от перевозки при наличии подтверждаемых
          медицинскими документами противопоказаний к полету на дату отправления
          воздушного судна, указанную в билете.
        </p>
      </div>
      <div
        v-else-if="this.selectedReason.name == 'Иное'"
        class="refund-main__reason-description__item"
      >
        <p class="refund-main__reason-description__item-text">
          Требуется подробно описать причину и приложить подтверждающие
          документы.
        </p>
      </div>
      <div v-if="this.selectedReason.name == 'Иное'">
        <Editor
          class="support-request__form-description__textarea"
          v-model="description"
          editorStyle="height: 160px"
        >
          <template #toolbar>
            <span class="ql-formats">
              <button class="ql-bold"></button>
              <button class="ql-italic"></button>
              <button class="ql-underline"></button>
              <button class="ql-list" value="ordered"></button>
            </span>
          </template>
        </Editor>
      </div>
      <div class="support-request__form-upload">
        <p class="useroffer-uploadedfiles">
          Прикреплённые файлы
          <span class="request__optional">(необязательно)</span>
        </p>
        <div v-if="this.isDocsLoading">
          <Skeleton
            class="useroffer-uploadedfiles__existing-file__skeleton"
            width="100%"
            height="20px"
          />
        </div>
        <div v-else>
          <div v-if="this.userDocs.documents !== null">
            <div
              v-for="(document, index) in this.userDocs.documents"
              :key="index"
              class="useroffer-uploadedfiles__existing"
            >
              <a
                :href="document.Url"
                class="useroffer-uploadedfiles__existing-file"
                >{{ document.Name }}</a
              >
            </div>
          </div>
        </div>

        <input
          type="file"
          id="files"
          ref="files"
          multiple
          accept=".png, .jpg, .jpeg, .pdf, .tiff, .pjpeg, .pjp"
          @change="handleFileUpload()"
          class="support-request__form-upload__mob-input"
        />
        <label for="files" class="support-request__form-upload__mob"
          >Добавить файлы</label
        >
        <p class="support-request__form-upload__alert" v-show="this.fileSizeEx">
          Размер файлов не должен привышать 20Мб, размер одного файла - не более
          10Мб.
        </p>
        <p
          class="support-request__form-upload__alert"
          v-show="this.maxFileCount"
        >
          Количество файлов - не более 10ти.
        </p>
        <p
          class="support-request__form-upload__alert"
          v-show="this.wrongFileFormat"
        >
          Допустимые форматы файлов: .png, .jpg, .jpeg, .pdf, .tif, .tiff,
          .pjpeg, .pjp
        </p>

        <div v-if="this.showAttachedFiles && this.files !== null">
          <div
            v-for="(file, index) in this.files.files"
            :key="index"
            class="support-request__form-upload__show"
          >
            <p class="support-request__form-upload__show-item">
              {{ file.name }}
            </p>
          </div>
        </div>
      </div>
      <Button
        type="button"
        label="Отправить файлы"
        :loading="loading"
        class="refund-main__submitbtn"
        @click="sendAttachment"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import InputText from "primevue/inputtext";
import axios from "axios";
import Ripple from "primevue/ripple";
import Button from "primevue/button";
import Skeleton from "primevue/skeleton";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import { useRouter, useRoute } from "vue-router";
import Dropdown from "primevue/dropdown";
import Editor from "primevue/editor";
import { useToast } from "primevue/usetoast";
import Toast from "primevue/toast";
import store from "../store";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "Offer",
  components: {
    InputText,
    Button,
    Skeleton,
    Accordion,
    AccordionTab,
    Dropdown,
    Editor,
    Toast,
  },
  props: ["offerId"],
  setup(props) {
    const toast = useToast();
    const showSuccess = () => {
      toast.add({
        severity: "success",
        summary: "Выполнено!",
        detail: "Файлы добавлены",
        life: 3000,
      });
    };
    const isLoading = ref(false);
    const isDocsLoading = ref(false);
    const selectedReason = ref({ name: "" });
    const description = ref("");
    const subIndex = ref([
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
    ]);
    const reasons = ref([
      { name: "Добровольный возврат" },
      { name: "Отмена или задержка рейса" },
      { name: "Изменение перевозчиком маршрута" },
      { name: "Выполнение рейса не по расписанию" },
      { name: "Не предоставили место на рейсе" },
      { name: "Задержали при досмотре" },
      { name: "Нарушена стыковка" },
      { name: "Болезнь пассажира или члена его семьи" },
      { name: "Необеспечение обслуживания по классу" },
      { name: "Неправильное оформление билета" },
      { name: "Иное" },
    ]);
    const isMailInvalid = ref(false);
    const isPhoneInvalid = ref(false);
    const isReasonInvalid = ref(false);
    const router = useRouter();
    const route = useRoute();
    const passMail = ref("");
    const passPhone = ref("");
    const reason = ref("");
    const loading = ref(false);
    const offer = ref(null);
    const checkedOrder = ref(null);
    const error = ref(null);
    const userDocs = ref(null);
    const files = ref<any | null>(null);
    const wrongFileFormat = ref(false);
    const maxFileCount = ref(false);
    const fileSizeEx = ref(false);
    const checkBeforeSumbit = ref(true);
    const showAttachedFiles = ref(false);
    const adjError = ref(false);
    const allUnchecked = ref(false);
    const getUserOffer = async () => {
      isLoading.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/GetUserOffer?offerId=${props.offerId}`
        );
        if (json.data) {
          let fetchedOrders = await json.data;

          offer.value = fetchedOrders;
          selectedReason.value.name = fetchedOrders.offer.Description.trim();

          isLoading.value = false;
        } else {
          console.log("error!");
          isLoading.value = false;
        }
        console.log(offer.value);
        
        isLoading.value = false;
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    const getUserDocs = async () => {
      isDocsLoading.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/LoadDocuments?offerId=${props.offerId}`
        );
        if (json.data) {
          let fetchedOrders = await json.data;

          userDocs.value = fetchedOrders;

          isDocsLoading.value = false;
        } else {
          console.log("error!");
          isDocsLoading.value = false;
        }
      } catch (err) {
        isDocsLoading.value = false;
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    const sendAttachment = async () => {
      let bodyFormData = new FormData();
      if (files.value) {
        files.value.files.forEach((el: any) => {
          bodyFormData.append(el.name, el, el.name);
        });
      }
      if (maxFileCount.value || fileSizeEx.value || wrongFileFormat.value) {
        return;
      } else {
        loading.value = true;
        try {
          axios({
            method: "POST",
            url: `https://www.biletdv.ru/customer/IBEServices/AddAttachmentToOffer?offerId=${props.offerId}`,
            data: bodyFormData,
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
          }).then((res) => {
            loading.value = false;
            if (res.status == 200) {
              getUserDocs();
            }
          });
        } catch (err) {
          if (err.response.status == 401) {
            store.dispatch("auth/logout");
            router.push("/login");
          }
        }
      }
    };
    return {
      passMail,
      passPhone,
      reason,
      isLoading,
      isDocsLoading,
      loading,
      offer,
      error,
      checkedOrder,
      router,
      route,
      isMailInvalid,
      isPhoneInvalid,
      isReasonInvalid,
      reasons,
      selectedReason,
      description,
      subIndex,
      files,
      wrongFileFormat,
      maxFileCount,
      fileSizeEx,
      checkBeforeSumbit,
      showAttachedFiles,
      adjError,
      allUnchecked,
      getUserOffer,
      sendAttachment,
      getUserDocs,
      userDocs,
    };
  },
  data() {
    return {
      month: [
        "янв",
        "фев",
        "мар",
        "апр",
        "мая",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ],
    };
  },
  methods: {
    handleFileUpload() {
      if (this.files !== null) {
        let filesSize = 0;
        if (this.files.files.length > 0) {
          this.showAttachedFiles = true;
        } else {
          this.showAttachedFiles = false;
        }
        for (let i = 0; i < this.files.length; i++) {
          if (this.files.files[i].size > 10485760) {
            this.fileSizeEx = true;
          } else {
            this.fileSizeEx = false;
          }
          if (
            this.files.files[i].type !== "image/png" &&
            this.files.files[i].type !== "image/jpg" &&
            this.files.files[i].type !== "image/jpeg" &&
            this.files.files[i].type !== "image/pjp" &&
            this.files.files[i].type !== "image/pjpeg" &&
            this.files.files[i].type != "application/pdf" &&
            this.files.files[i].type !== "image/tiff"
          ) {
            console.log("must be true" + this.files.files[i].type);
            this.wrongFileFormat = true;
          } else {
            console.log("must be false" + this.files.files[i].type);
            this.wrongFileFormat = false;
          }

          filesSize += this.files.files[i].size;
        }
        if (filesSize > 22020096) {
          this.fileSizeEx = true;
        } else {
          this.fileSizeEx = false;
        }
        if (this.files.files.length > 10) {
          this.maxFileCount = true;
        } else {
          this.maxFileCount = false;
        }
        if (this.files.files.length == 0) {
          this.wrongFileFormat = false;
        }
        if (this.maxFileCount || this.fileSizeEx || this.wrongFileFormat) {
          this.checkBeforeSumbit = false;
        } else {
          this.checkBeforeSumbit = true;
        }
        console.log(this.files.files[0]);
        console.log(this.wrongFileFormat);
      }
    },
    getWeekDay(date: any) {
      let days = ["вс", "пн", "вт", "ср", "чт", "пт", "сб"];
      let weekDay = new Date(date);
      return days[weekDay.getDay()];
    },
    getDate(date: any) {
      let month = [
        "янв",
        "фев",
        "мар",
        "апр",
        "мая",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ];
      let monthNum = new Date(date);
      return monthNum.getDate() + " " + month[monthNum.getMonth()] + " " + monthNum.getFullYear();
    },
    nameCaseChanger(name: string): string {
      let splitedName = name.split(" ");
      let firstLetterUpperCase = "";
      let normalName = "";
      for (let i = 0; i < splitedName.length; i++) {
        firstLetterUpperCase =
          splitedName[i][0].toUpperCase() +
          splitedName[i].slice(1).toLowerCase();
        normalName += firstLetterUpperCase + " ";
      }
      return normalName;
    },
    submitCheck() {
      if (
        this.passMail == "" &&
        this.passPhone == "" &&
        this.selectedReason.name == ""
      ) {
        this.isMailInvalid = true;
        this.isPhoneInvalid = true;
        this.isReasonInvalid = true;
      } else if (this.passMail == "" && this.passPhone == "") {
        this.isMailInvalid = true;
        this.isPhoneInvalid = true;
      } else if (this.passPhone == "" && this.selectedReason.name == "") {
        this.isPhoneInvalid = true;
        this.isReasonInvalid = true;
      } else if (this.passMail == "" && this.selectedReason.name == "") {
        this.isMailInvalid = true;
        this.isReasonInvalid = true;
      } else if (this.passMail == "") {
        this.isMailInvalid = true;
      } else if (this.passPhone == "") {
        this.isPhoneInvalid = true;
      } else if (this.selectedReason.name == "") {
        console.log(this.selectedReason);
        this.isReasonInvalid = true;
      } else {
        this.isMailInvalid = false;
        this.isPhoneInvalid = false;
        this.isReasonInvalid = false;
      }
    },
    getCreatedDate(date: any) {
      function pad(n: any) {
        return n < 10 ? "0" + n : n;
      }
      const now = new Date(date);
      const tz = now.getTimezoneOffset();
      const sign = tz > 0 ? "-" : "+";
      const hours = pad(Math.floor(Math.abs(tz) / 60));
      const minutes = pad(Math.abs(tz) % 60);
      const tzOffset = sign + hours + ":" + minutes;
      const localDateTime =
        now.getFullYear() +
        "-" +
        pad(now.getMonth() + 1) +
        "-" +
        pad(now.getDate()) +
        "T" +
        pad(now.getHours()) +
        ":" +
        pad(now.getMinutes()) +
        ":" +
        pad(now.getSeconds());
      const eventDate = {
        utc: now.toISOString(),
        local: localDateTime,
        tzOffset: tzOffset,
      };

      const localDateString = eventDate.local;
      const localDate = new Date(localDateString);

      let created: any = new Date(localDate);
      if (tz < 0) {
        created.setHours(
          created.getHours() - 10 + Math.floor(Math.abs(tz) / 60)
        );
        created.setMinutes(created.getMinutes() + (Math.abs(tz) % 60));
      } else if (tz > 0) {
        created.setHours(
          created.getHours() - 10 - Math.floor(Math.abs(tz) / 60)
        );
        created.setMinutes(created.getMinutes() - (Math.abs(tz) % 60));
      }

      let createdDay = created.getDate();
      let createdMonth: any = created.getMonth();
      let createdYear = created.getFullYear();
      let createdHours = function () {
        if (created.getHours() < 10) {
          return "0" + created.getHours();
        } else {
          return created.getHours();
        }
      };
      let createdMinutes = function () {
        if (created.getMinutes() < 10) {
          return "0" + created.getMinutes();
        } else {
          return created.getMinutes();
        }
      };

      return (
        createdDay +
        " " +
        this.month[createdMonth] +
        " " +
        createdYear +
        " " +
        createdHours() +
        ":" +
        createdMinutes() +
        " (UTC " +
        tzOffset +
        ")"
      );
    },
    getOfferStatus(num: number) {
      if (num == 10) {
        return "Заявка создана";
      } else if (num == 20) {
        return "Заявка в работе";
      } else if (num == 30) {
        return "Заявка обработана";
      } else if (num == 40) {
        return "Сообщение";
      }
    },
  },
  created() {
    this.getUserOffer();
    this.getUserDocs();
  },
  directives: {
    ripple: Ripple,
  },
});
</script>

<style>
.existingrefund-header {
  padding: 10px 5px 5px 5px;
  border-radius: 5px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  width: 100%;
  background: #ffffff;
  margin-bottom: 15px;
}

.useroffer-uploadedfiles {
  font-size: 16px;
  margin-top: 10px;
}

.useroffer-uploadedfiles__existing {
  margin-top: 7px;
  margin-bottom: 7px;
}

.useroffer-uploadedfiles__existing-file {
  color: #2196f3;
}

.useroffer-uploadedfiles__existing-file__skeleton {
  margin-top: 7px;
  margin-bottom: 7px;
}
</style>
